import Proj1 from "../assets/proj1.jpg";
import Proj2 from "../assets/proj2.jpg";
import Proj3 from "../assets/proj3.jpg";
import Proj4 from "../assets/proj4.jpg";


export const ProjectList=
  
 [
  {
    name: "Github User App",
    image: Proj1,
    skills: "JavaScript,React,CSS,Bootstrap,Github_user_API,Authentication",
  },
  {
    name: "Basic Website",
    image: Proj2,
    skills: "React,Bootstap,Javascript",
  },
  {
    name: "Product Management ",
    image: Proj3,
    skills: "Java,swing, Mysql",
  },
  {
    name: "Contact Application",
    image: Proj4,
    skills: "React,Bootsrtap,Javascript,Firebase_Realtime_Database,Authentication ",
  },
]

